import api from '../tracker/trackerAPI'
import { FullStoryAPI } from 'react-fullstory'

export const postMarketingInfos = (userInfos) => (dispatch) => {
	api.postMarketingInfos(userInfos)
	dispatch(setUserMail(userInfos.mail))
}

export const setUser = (userInfos) => (dispatch) => {
	dispatch(setUserAskInfos(userInfos.askForContactInfo))
	dispatch(setUserMail(userInfos.userMail))

	let userDatas = userInfos.creditorInfo
	if (userInfos.userIsBeneficiary) {
		userDatas = userInfos.beneficiaryInfo
	}
	FullStoryAPI('identify', userDatas.name, {
		Name: userDatas.name,
		isBeneficiary: userInfos.userIsBeneficiary,
		isTest: !window.location.href.includes(process.env.REACT_APP_DOMAIN_NAME)
	})
}

export const setUserMail = (payload) => ({
	type: 'SET_USER_MAIL',
	payload: payload
})

export const setUserAskInfos = (payload) => ({
	type: 'SET_ASK_INFOS',
	payload: payload
})

export const setUserLanguage = (userOption) => ({
	type: 'SET_USER_LANGUAGE',
	payload: userOption
})
